import { useContext, useEffect } from "react";
import { GlobalContext } from "../../context/GlobalState";

import CircularProgress from "@material-ui/core/CircularProgress";

import { useMediaQuery } from "react-responsive";

export default function ClassesModal() {
  const {
    assignedGrades,
    selectedClass,
    setSectionId,
    setSelectedClass,
    setAssignedSubjects,
  } = useContext(GlobalContext);
  const isSmallScreen = useMediaQuery({
    query: "(max-width:450px)",
  });
  const handleSelectClass = (e, data) => {
    const sectionId = data.subjects.length && data.subjects[0].sectionId;
    setSectionId(sectionId);
    localStorage.setItem("currentsectionId", sectionId);
    localStorage.setItem("gradeSection", e.target.value);
    setSelectedClass(e.target.value);
  };

  const applyGrade = () => {
    let tempArr = [];
    assignedGrades.grades.forEach((assignedClass) => {
      if (selectedClass === assignedClass._id) {
        window.localStorage.setItem("selectedClass", assignedClass._id);
        assignedClass.subjects.forEach((data) => {
          localStorage.setItem("sectionIdTask", data.sectionId);
          tempArr.push({
            subject: data.subject,
            subjectId: data.subjectId,
            subjectData: data.subjectData,
          });
        });
      }
    });

    setAssignedSubjects([tempArr]);
  };

  useEffect(() => {
     applyGrade();
  }, [selectedClass]);

  useEffect(() => {
  return () => {
    // Remove backdrop manually
    const backdrop = document.querySelector(".modal-backdrop");
    if (backdrop) backdrop.remove();

    // Remove modal-open class from body
    document.body.classList.remove("modal-open");

    // Reset body styles
    document.body.style = "";
  };
}, []);

  return (
    <div
      className="modal fade classModel"
      id="classesModal"
      tabIndex="-1"
      aria-labelledby="classesModalLabel"
      // data-bs-backdrop="static"
      aria-hidden="true"
    >
      <div className="modal-dialog  modal-dialog-centered">
        <div className="modal-content">
          <div className="modal-header">
            <h4 className="modal-title" id="classesModalLabel">
              GRADES
            </h4>
            {/* <button
                type='button'
                className='btn-close'
                data-bs-dismiss='modal'
                aria-label='Close'
              ></button> */}
          </div>
          {assignedGrades.loading ? (
            <div className="text-center">
              <CircularProgress
                style={{ color: "#FF075B", fontWeight: "600" }}
              />
            </div>
          ) : (
            <div className="modal-body">
              <div className="row">
                {assignedGrades.grades.map((assignedClass, index) => (
                  <div
                    className={isSmallScreen ? "col-4" : "col-sm-3"}
                    key={index}
                  >
                    <div className="form-check">
                      <input
                        className="form-check-input"
                        type="radio"
                        name="classRadio"
                        id={assignedClass._id}
                        onChange={(e) => handleSelectClass(e, assignedClass)}
                        required
                        value={assignedClass._id}
                      />
                      <label
                        className="form-check-label"
                        htmlFor={assignedClass._id}
                      >
                        {assignedClass._id}
                      </label>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          )}

          <div className="modal_button_container">
            <button
              type="button"
              id="ModalToggler"
              className="btn  classModelBtnApply"
              data-bs-dismiss="modal"
            >
              Apply
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
